//
// TableColumns.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractTableColumn";
import "./TableLabel";

var TableColumns = createModule("BIRD::TableColumns", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::AbstractTableColumn"], EventDispatcher, [
    ,
    {
        sortDisabled: 2,
        columns: [1],
        isStacked: 2,
        headersHidden: 2,
        labels: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default TableColumns;
